import * as React from "react";
import {  RouteComponentProps,  withRouter } from "react-router-dom";
import { CommonWorkout, CommonAcquisition } from "../../types";
import "./WorkoutPreview.css";
import { withTranslation, WithTranslation } from "react-i18next";
import {  Card, Image } from "semantic-ui-react";
import { Dispatch } from "redux";
import { formatTime } from "../../utils/Formatter";

interface WorkoutPreviewProps extends RouteComponentProps, WithTranslation {
    workout: (CommonWorkout | CommonAcquisition) & { 
        time?: number; 
        img?: string; 
        title?: string;
        subtitle?: string;
        author?: string;
        content?: any;
        type?: string;
        subtype?: string;
        date?: string | Date;
        description?: string;
    } | {
        id: number;
        type?: string;
        subtype?: string;
        date?: string | Date;
        img?: string;
        title?: string;
        subtitle?: string;
        author?: string;
        description?: string;
        content?: any;
        time?: number;
    };
    dispatch: Dispatch<any>;
}

class WorkoutPreview extends React.Component<WorkoutPreviewProps> {
    private navigate = () => {
            if(this.props.workout.id == 0){
                this.props.history.push(`/raw`);
            }
            else{
                this.props.history.push({
                    pathname:`/workouts/${this.props.workout}`,
                    state: {workout: this.props.workout}
                });
            }
            
    }
    img=()=>{
        let img;
        try{
            const imgPath = this.props.workout.img || 'Workout.png';
            img = require(`../../assets/images/workout/${imgPath}`);
        }catch{
            img= require(`../../assets/images/workout/Workout.png`);
        }
        return img;
    }
    time=()=>{
        if(this.props.workout.time && typeof this.props.workout.time === 'number')
            return(<div className="workoutDuration">{formatTime(this.props.workout.time)}</div>);
        else 
            return null
    }
    public render() {
        return (
            <div className='workout-preview'>
                    <Card onClick={this.navigate}>
                      <Image src={this.img()} wrapped={true} ui={false}/>
                        {this.time()}
                        <Card.Content>
                            <Card.Header>{String(this.props.t(this.props.workout.title || (this.props.workout as CommonWorkout).name || ''))}</Card.Header>
                            <Card.Meta>
                                {String(this.props.t((this.props.workout as any).subtitle || '') || '')}
                            </Card.Meta>
                        </Card.Content>
                    </Card>
            </div>
        );
    }
}

export default withTranslation("workout")(withRouter(WorkoutPreview));
